import { PAMUserApi } from './../../config/api-url';
import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { dashboardApi } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  constructor(private apiService: ApiService) { }

  getSellerDashboardFull(userId: string | number, companyId: string | number): any {
    return this.apiService.get(`${dashboardApi.getSellerDashboardFull}${userId}?companyId=${companyId}`);
  }

  getManagerDashboardFull(compId: string | number, sellerIds: number[] = []): any {
    const base = `${dashboardApi.getManagerDashboardFull}?companyId=${compId}`;
    const url = sellerIds.length > 0 ? `${base}&userIds=${sellerIds.join(',')}` : base;
    return this.apiService.get(url);
  }

  getNotifications(params: object): any {
    return this.apiService.get(`${dashboardApi.getNotifications}`, params as any);
  }

  postDeleteNotification(body: object): any {
    return this.apiService.post(`${dashboardApi.postDeleteNotification}`, body);
  }

  getSellerChallenges(userId: string | number, companyId: string | number, params: object): any {
    return this.apiService.get(`${dashboardApi.getSellerChallenges}${userId}?companyId=${companyId}`, params as any);
  }

  getManagerActivationChallenges(userId: string | number): any {
    return this.apiService.get(`${dashboardApi.getManagerActivationChallenges}${userId}`);
  }

  postBudgetStatsCaps(params: { companyId: string | number; userId: string | number; quarterOption: string }): any {
    return this.apiService.post(`${dashboardApi.postBudgetStatsCaps}?companyId=${params.companyId}&userId=${params.userId}&quarterOption=${params.quarterOption}`);
  }

  updateNotification(body: object): any {
    return this.apiService.post(`${dashboardApi.updateNotification}`, body);
  }

  getNotificationsCount(): any {
    return this.apiService.get(`${dashboardApi.getNotificationsCount}`);
  }

  getRegionList(userId: string | number): any {
    return this.apiService.get(`${PAMUserApi.getTheatersRequest}${userId}`);
  }

  getCountryListRequest(userId: string | number, region: string): any {
    return this.apiService.get(`${PAMUserApi.getCountryGroupsRequest}${userId}?theater=${region}`);
  }

  getBeGeoIdsRequest(paramReq: object, search?: string, size?: number, page?: number): any {
    let url = `${PAMUserApi.getBeGeoIdsRequest}`;
    const queryParts: string[] = [];
    if (size !== undefined) {
      queryParts.push(`size=${size}`);
    }
    if (page !== undefined) {
      queryParts.push(`page=${page}`);
    }
    if (search !== undefined && search !== '') {
      queryParts.push(`search=${encodeURIComponent(search)}`);
    }
    if (queryParts.length > 0) {
      url = `${url}?${queryParts.join('&')}`;
    }
    return this.apiService.post(url, paramReq);
  }

  getQuarterList(): any {
    return this.apiService.get(`${dashboardApi.quarterList}`);
  }
}
